import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Draft = new StatusEnumItem({
  id: '9C57143E-4007-4220-BFB0-925A44F9A418',
  name: 'Draft',
  description:
    'The Field Design Change is ready to be created, but not ready to advance through the FDC Tracker',
  priority: 0,
})
const PendingLevelConcurrences = new StatusEnumItem({
  id: '4EAE3DF1-6FC0-40BB-B1C1-45AF76A580DE',
  name: 'Pending Level Concurrences',
  description:
    'Concurrers accept or reject the Concurrence Level of the Field Design Change. Rejected Field Design Changes go back to Draft',
  priority: 1,
})
const PendingApprovals = new StatusEnumItem({
  id: '254585F2-4BD1-462B-8B04-DD85615FE1FF',
  name: 'Pending Approvals',
  description:
    'Approvers check off Approval Groups associated with the Field Design Change. Authorized Users may revert the Field Design Change back to Pending Level Concurrences',
  priority: 2,
})
const Closed = new StatusEnumItem({
  id: '57F82068-83D2-4B98-9E62-9C174F117A58',
  name: 'Closed',
  description:
    'The Field Design Change has fully advanced through the FDC Tracker workflow. Its associated SharePoint folder is locked from editing',
  priority: 3,
})
const Unlocked = new StatusEnumItem({
  id: 'C1FB06D0-F12A-4014-A230-4C7B04725000',
  name: 'Unlocked',
  description:
    'The Field Design Change is closed, but its associated SharePoint folder has been unlocked for editing',
  priority: 4,
})

export type FieldDesignChangeStatusItem =
  | typeof Draft
  | typeof PendingLevelConcurrences
  | typeof PendingApprovals
  | typeof Closed
  | typeof Unlocked

class FieldDesignChangeStatusEnum extends StatusEnum<
  'FieldDesignChangeStatus',
  FieldDesignChangeStatusItem,
  FieldDesignChangeStatusItem['name'],
  FieldDesignChangeStatusItem['id'],
  FieldDesignChangeStatusItem['priority']
> {
  readonly typename = 'FieldDesignChangeStatus'
  get values() {
    return [
      this.Draft,
      this.PendingLevelConcurrences,
      this.PendingApprovals,
      this.Closed,
      this.Unlocked,
    ]
  }
  readonly Draft = Draft
  readonly PendingLevelConcurrences = PendingLevelConcurrences
  readonly PendingApprovals = PendingApprovals
  readonly Closed = Closed
  readonly Unlocked = Unlocked
}

export const FieldDesignChangeStatus = new FieldDesignChangeStatusEnum()
